<template>
  <button @click="handleClick" :style="{ width: width + 'px', height: height + 'px' }" :class="{inverse:inverse}">
    <img :src="require(`@/assets/icons/${icon}.svg`)" alt="" v-if="icon" />
    <div class="text" :style="{fontSize: fontSize + 'px', fontWeight: fontWeight}">{{ text }}</div>
  </button>
</template>

<script>

export default {
  name: 'BtnPrimary',
  props: {
    text: {
      type: String,
      default: 'name me',
    },
		icon: String,
    width: [String, Number],
    height: [String, Number],
    fontSize: [String, Number],
    fontWeight: String,
    inverse: Boolean
  },
  methods: {
    handleClick(e) {
      this.$emit('click',e);
    }
  },
  components: { 
  },
};
</script>

<style lang="scss" scoped>
button {
  max-width: 280px;
  width: 100%;
  /* width: 80px; */
  background-color: var(--main-orange);
  color: white;
  font-size: 18px;
  font-weight: bold;
  padding: 20px 0 22px;
  .text {
    font-size: 18px;
    font-weight: bold;
  }
  &.inverse {
    background-color: white;
    color: var(--main-orange);
  }
  @media (max-width: $mobile) {
    flex: 1;
    max-width: unset;
  }
}
</style>
